import React from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import parse from 'autosuggest-highlight/parse'
import match from 'autosuggest-highlight/match'
import api from 'api/api'
import Outfit from 'components/OutfitDemo/Outfit'
import MainGarment from 'components/OutfitDemo/MainGarment'
import { Spinner } from 'react-bootstrap'
// import img from 'react-image'

const style = theme => ({
  root: {
    display: 'inline-block'
    // marginLeft: '38px'
  },
  secondaryCard: {
    boxSizing: 'border-box !important',
    height: '245px',
    width: '820px',
    border: '1px solid #DEDEDE',
    borderRadius: '5px',
    backgroundColor: '#FFFFFF'
  },
  searchContainer: {
    display: 'inline-block !important',
    marginBottom: '20px'
  },
  searchBar: {
    backgroundColor: 'white'
  },
  searchContainerText: {
    display: 'inline-block',
    height: '24px',
    width: '57px',
    opacity: '0.5',
    color: '#000000',
    fontFamily: 'Montserrat',
    fontSize: '10px',
    fontWeight: '600',
    lineHeight: '24px'
  },
  autocompleteBar: {
    display: 'inline-flex',
    marginLeft: '19px',
    width: '610px'
  },
  verticalTextPosition: {
    position: 'relative',
    top: '115px',
    left: '-111px'
  },
  verticalTextPosition2: {
    position: 'relative',
    top: '115px',
    left: '-111px'
  },
  verticalText: {
    textAlign: 'center',
    height: '14px',
    width: '245px',
    color: '#4C4C51',
    fontFamily: '"SF Pro Text"',
    fontSize: '12px',
    lineHeight: '14px',
    transform: 'rotate(270deg)'
  },
  rectangle1: {
    height: '243px',
    width: '24px',
    borderRadius: '5px 0 0 5px',
    backgroundColor: '#FFEEEE'
  },
  rectangle2: {
    height: '243px',
    width: '24px',
    borderRadius: '5px 0 0 5px',
    backgroundColor: '#E8F3FF'
  },
  rectangle3: {
    height: '243px',
    width: '24px',
    borderRadius: '5px 0 0 5px',
    backgroundColor: '#FFEEEE'
  },
  outfitsContainer: {
    position: 'relative',
    top: '-240px',
    right: '-24px',
    marginLeft: '10px',
    paddingTop: '15px',
    width: '95%'
  },
  noOutfit: {
    paddingTop: '30px',
    textAlign: 'center'
  }
})

class OccasionDemo extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      categories: [],
      name: props.field,
      garments: [],
      loading: true
    }
    this.handleRequestGarments = this.handleRequestGarments.bind(this)
  }

  async componentDidMount () {
    const categories = await api.getCategories()
    const filteredCategories = []
    await this.handleRequestGarments([], [])
    for (var i = 0; i < this.state.garments.length; i++) {
      for (var categItem in categories) {
        if (
          filteredCategories.map(e => e._id).indexOf(this.state.garments[i].garmentType) === -1 &&
          categories[categItem]._id === this.state.garments[i].garmentType
        ) {
          filteredCategories.push(categories[categItem])
        }
      }
    }
    this.setState({ categories: filteredCategories })
  }

  async handleRequestGarments (e, value) {
    this.setState({ loading: true })
    // if (value.length === 0) {
    //   this.setState({ loading: false })
    //   return
    // }

    const categoryRestrictions = value.map(value => value._id)
    const body = {
      outfit_restrictions: { approved: 2, occasion_restriction: [25, 27, 32] },
      return_garments: true,
      query_restrictions: { category_ids_restriction: categoryRestrictions.length === 0 ? null : categoryRestrictions },
      n_queries: 33,
      sort_by: { _id: 1 },
      n_outfits_per_query: 3,
      sample_outfits: false,
      ignore_favourite_users: true
    }
    const results = (await api.getOutfits(body)).data
    if (results.garments === undefined) {
      this.setState({ garments: [], loading: false })
    } else {
      for (var i = 0; i < results.garments.length; i++) {
        const outfits = results.garments[i].outfits
        if (outfits.length < 3) {
          results.garments[i].outfits = [outfits[0], outfits[0], outfits[0]]
        } else {
          results.garments[i].outfits = outfits.slice(0, 3)
        }
      }
      this.setState({ garments: [] })
      this.setState({ garments: results.garments, loading: false })
    }
  }

  render () {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <div className={classes.searchContainer}>
          <div className={classes.searchContainerText}>
            CATEGORY
          </div>
          <Autocomplete
            className={classes.autocompleteBar}
            multiple
            id='tags-standard'
            options={this.state.categories}
            getOptionLabel={option => option.name}
            defaultValue=''
            onChange={this.handleRequestGarments}
            renderInput={params => (
              <TextField
                className={classes.searchBar}
                {...params}
                variant='outlined'
                label=''
                placeholder=''
                margin='normal'
                fullWidth
              />
            )}
            renderOption={(option, { inputValue }) => {
              const matches = match(option.name, inputValue)
              const parts = parse(option.name, matches)

              return (
                <div>
                  {parts.map((part, index) => (
                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                      {part.text}
                    </span>
                  ))}
                </div>
              )
            }}
          />
        </div>
        {this.state.loading
          ? <div className='outfit-loading-spinner'>
            <Spinner animation='border' role='status' style={{ padding: '50px' }}>
              <span className='sr-only'>Loading...</span>
            </Spinner>
          </div> : this.state.garments.length === 0
            ? <div className={classes.noOutfit}>
              Unfortunately there are no available outfits for your selection.
            </div>
            : this.state.garments.map((garment, key) => {
              return (
                <Grid container spacing={4} key={key} wrap='nowrap'>
                  <Grid item>
                    <MainGarment garment={garment} />
                  </Grid>
                  <Grid item>
                    <Grid container direction='column' spacing={2}>
                      <Grid item>
                        <Card className={classes.secondaryCard}>
                          <div className={classes.rectangle1}>
                            <p className={`${classes.verticalText} ${classes.verticalTextPosition}`}>GOING OUT</p>
                          </div>
                          <div className={classes.outfitsContainer}>
                            <Grid container justify='space-evenly' wrap='nowrap'>
                              <Outfit outfit={garment.outfits[0].garments} />
                            </Grid>
                          </div>
                        </Card>
                      </Grid>
                      <Grid item>
                        <Card className={classes.secondaryCard}>
                          <div className={classes.rectangle2}>
                            <div className={`${classes.verticalText} ${classes.verticalTextPosition}`}>DATE</div>
                          </div>
                          <div className={classes.outfitsContainer}>
                            <Grid container justify='space-evenly' wrap='nowrap'>
                              <Outfit outfit={garment.outfits[1].garments} />
                            </Grid>
                          </div>
                        </Card>
                      </Grid>
                      <Grid item>
                        <Card className={classes.secondaryCard}>
                          <div className={classes.rectangle3}>
                            <div className={`${classes.verticalText} ${classes.verticalTextPosition2}`}>BUSINESS SMART</div>
                          </div>
                          <div className={classes.outfitsContainer}>
                            <Grid container justify='space-evenly' wrap='nowrap'>
                              <Outfit outfit={garment.outfits[2].garments} />
                            </Grid>
                          </div>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )
            })}
      </div>
    )
  }
}

export default withStyles(style)(OccasionDemo)
